import React, { Fragment, useState, useEffect } from 'react';
import { Notification, Table, Modal, Box, Button, Delete, Progress } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faEye } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';
import NotificationService from '../../../services/notification';
import NotificationsDetail from '../detail';
import NotificationsNewForm from '../new_form';
import PaginationCustom from '../../components/PaginationCustom';

const config = {
  activeModal: false,
  page: null
}

const NotificationsList = () => {
  const [notifications, setNotifications] = useState([]);
  const [pageOfItems, setPageOfItems] = useState([]);
  const [activeProgress, setActiveProgress] = useState(true);
  const [status, setStatus] = useState('');
  const [params, setParams] = useState(config);

  useEffect(() =>{
    fetchNotifications();
  },[])

  const fetchNotifications = async () => {
    try {
      const response = await NotificationService.index();
      setNotifications(response.data.notifications.reverse());
    } catch(e) {
      if (e.response)
        setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
      else
        setStatus(['danger', `${e.message}`]);
    }
    setActiveProgress(false);
  }

  const renderNotificationDetail = (index) => {
    setParams({
      activeModal: true,
      page: <NotificationsDetail {...pageOfItems[index]} />
    })
  }

  const renderNotificationNewForm = () => {
    setParams({
      activeModal: true,
      page: <NotificationsNewForm fetchNotifications={fetchNotifications}/>
    })
  }

  const deleteNotification = async (index) => {
    if (window.confirm('Confirma a exclusão ?')) {
      const notification = pageOfItems[index];
      try {
        console.log('Notificação: ', notification);
        await NotificationService.delete(notification);
      } catch(e) {
        if (e.response)
          if (e.response.data.errors !== undefined)
            setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
          else
            setStatus(['danger', `${e.response.status}: ${e.response.data}`]);
        else
          setStatus(['danger', `${e.message}`]);
      }
      fetchNotifications();
    }
  }

  const renderModal = () => params.page;

  const closeModal = () => { 
    setParams(config);
  }

  const onChangePage = (ppageOfItems) => {
    setPageOfItems(ppageOfItems);
  }

  const renderNotifications = () => {
    if (pageOfItems.length === 0)
      return (
        <Table.Row key={0}>
          <Table.Cell colspan="9">
            { (activeProgress) ? <Progress size='small' color='custom-purple' /> : 'Não há notificações.' }
          </Table.Cell>
        </Table.Row>
      )
    else
      return (
        pageOfItems.map((notification, index) => (
          <Table.Row key={notification._id}>
            <Table.Cell>{notification.title}</Table.Cell>
            <Table.Cell>{moment(notification.createdAt).format('DD/MM/YYYY HH:mm:ss')}</Table.Cell>
            <Table.Cell>{notification.message.substring(0,60)} ...</Table.Cell>
            <Table.Cell textAlign='right'>
              <Button className="mr-3" size="small" color="custom-purple" outlined onClick={() => renderNotificationDetail(index)} title="Detalhe">
                <FontAwesomeIcon icon={faEye} />
              </Button>
              <Button size="small" color="danger" outlined onClick={() => deleteNotification(index)} title="Excluir">
                <FontAwesomeIcon icon={faTrashAlt} />
              </Button>
            </Table.Cell>
          </Table.Row>
        ))
      )
  }

  return (
    <Fragment>
      <Box>
        { 
          status!=='' && 
          <Notification color={status[0]}>
            <Delete as="button" onClick={() => setStatus('')} />
            {status[1]}
          </Notification>
        }
        <Table fullwidth>
          <Table.Head>
            <Table.Row>
              <Table.Heading>Título</Table.Heading>
              <Table.Heading>Criada em</Table.Heading>
              <Table.Heading>Mensagem</Table.Heading>
              <Table.Heading textAlign='right'>
                <Button size="small" color="custom-purple" title="Nova Notificação" onClick={()=>renderNotificationNewForm()}>
                  Nova Notificação
                </Button>
              </Table.Heading>
            </Table.Row>
          </Table.Head>
          <Table.Body>
            { renderNotifications() }
          </Table.Body>
        </Table>
        <PaginationCustom items={notifications} onChangePage={onChangePage} />
      </Box>

      <Modal closeOnBlur={true} closeOnEsc={true} active={params.activeModal} onClose={closeModal}>
        <Modal.Background onClick={closeModal} />
        <Modal.Content>
          { renderModal() }
        </Modal.Content>
        <Modal.Close />
      </Modal>
    </Fragment>
  )

}

export default NotificationsList;

